import {
  Component,
  OnInit,
  ChangeDetectorRef,
  ViewChild,
  TemplateRef,
  Output,
  EventEmitter,
  OnDestroy,
} from "@angular/core";
import { BsModalRef, BsModalService } from "ngx-bootstrap";
import { DocumentoService } from "@app/shared/services/documento.service";
import { DocumentoVO } from "@app/shared/vo/documentoVO";
import { FileUploader, FileItem } from "ng2-file-upload";
import { ResponseUploadFileVO } from "@app/shared/vo/response-upload-fileVO";
import { DocumentoGescorVO } from "@app/shared/vo/gescor/documento-gescorVO";
import { env } from "@env/environment";
import { ModaleConfermaComponent } from "../modale-conferma/modale-conferma.component";
import { ProtocolloService } from "@app/shared/services/protocollo.service";
import { ModaleControlloFirmaComponent } from "../modale-controllo-firma/modale-controllo-firma.component";
import { ModalePreviewComponent } from "@app/utility/components/modale-preview-pdf/modale-preview-pdf.component";
import { NotifierService } from "angular-notifier";
import { CaricaNuovaVersioneDocumentoRequestVO } from "@app/shared/vo/carica-nuova-versione-documento-requestVO";
import { AutenticazioneService } from "@app/shared/services/autenticazione.service";
import { ISubscription } from "rxjs-compat/Subscription";

@Component({
  selector: "app-modale-versioni-documento",
  templateUrl: "./modale-versioni-documento.component.html",
})
export class ModaleVersioniDocumentoComponent implements OnInit, OnDestroy {
  private config = {
    class: "modal-dialog modal-info modal-lg",
    animated: true,
  };
  public modalRef: BsModalRef;
  public uploaderDocumento: FileUploader;
  @ViewChild("templateModaleVersioniDocumento", { static: false })
  public modaleVersioniDocumento: TemplateRef<any>;
  @ViewChild("modaleConfermaNuovaVersione", { static: false })
  public modaleConfermaNuovaVersione: ModaleConfermaComponent;
  @ViewChild("templateModaleCaricamento", { static: false })
  public uploadModal: TemplateRef<any>;
  @ViewChild("appModaleControlloFirma", { static: false })
  modaleControlloFirma: ModaleControlloFirmaComponent;
  @ViewChild("appModalePreview", { static: false })
  previewModal: ModalePreviewComponent;

  @ViewChild("modaleConfermaRipristinaVersione", { static: false })
  public modaleConfermaRipristina: ModaleConfermaComponent;

  @Output()
  uploadEmit: EventEmitter<DocumentoGescorVO> = new EventEmitter();
  @Output()
  ripristinaEmit: EventEmitter<DocumentoGescorVO> = new EventEmitter();
  listaVersioniDocumento: DocumentoVO[];
  messages = {
    emptyMessage: "Nessun risultato",
    totalMessage: "in totale",
  };
  public loadingIndicator: boolean = false;
  private urlUpload = env.API_UPLOAD_BASE + env.URL_UPLOAD;
  public idRepository: string;
  public hash: string;
  public nomeFile: string;
  public riferimentiRepository = new DocumentoGescorVO();
  public statoUd: string;
  public progresso: number = 0;
  public esisteRichiestaFirmaDaEvadere: boolean;
  public statoRichiestaFirma: string;
  public isUtenteBlocco: boolean;
  idDocumento: string;
  //per modale
  titolo: string;
  testo: string;
  idDaRipristinare: string;
  hashDaRipristinare: string;
  nomeDaRipristinare: string;
  inCaricamento: boolean = false;
  idDocumentoPreview: string;
  showPreviewDoc: boolean = false;
  private accessToken: string;
  private utenteSubscription: ISubscription;

  constructor(
    private cdRef: ChangeDetectorRef,
    private protocolloService: ProtocolloService,
    private modalService: BsModalService,
    private notifierService: NotifierService,
    private documentoService: DocumentoService,
    private autenticazioneService: AutenticazioneService
  ) {
    this.utenteSubscription = this.autenticazioneService.utenteAnnounced$
      .filter(utente => utente != null)
      .subscribe(utente => { this.accessToken = utente.token; this.inizializzaUploader() });

  }

  ngOnInit() {
    this.progresso = 0;
  }

  openModal(
    idRepository: string,
    statoUd: string,
    isUtenteBlocco: boolean,
    esisteRichiestaFirma: boolean,
    statoRichiestaFirma: string
  ) {
    this.inCaricamento = false;
    this.idDocumento = idRepository;
    this.statoUd = statoUd;
    this.isUtenteBlocco = isUtenteBlocco;
    this.esisteRichiestaFirmaDaEvadere =
      esisteRichiestaFirma && statoRichiestaFirma === "INVIATA";
    this.statoRichiestaFirma = statoRichiestaFirma;

    this.inizializzaUploader();
    this.documentoService.getVersioniDocumento(idRepository).subscribe(
      (res) => {
        this.listaVersioniDocumento = res;
      },
      (err) => {
        console.log("caricaNuovaVersioneDocumento err", err);
      }
    );

    this.modalRef = this.modalService.show(
      this.modaleVersioniDocumento,
      this.config
    );
  }

  public download(index: string, nome: string) {
    console.log("download file ", index);

    let docToDownload: DocumentoVO = this.listaVersioniDocumento.filter(
      (entry) => entry.idRepository === index
    )[0];
    if (docToDownload === undefined) {
      docToDownload = new DocumentoVO();
      docToDownload.idRepository = index;
      docToDownload.nome = nome;
    }
    this.protocolloService.downloadFileProgress(docToDownload);
  }

  inizializzaUploader() {
    this.uploaderDocumento = new FileUploader({
      url: this.urlUpload,
      autoUpload: true,
      authToken: "Bearer " + this.accessToken,
    });
    this.progresso = 0;
    this.hash = "";
    this.idRepository = "";
    this.nomeFile = "";
    this.uploaderDocumento.onErrorItem = (item: any, response: any) => {
      console.log("[ModaleAggiungiUd.constructor] upload error ", response);
      this.loadingIndicator = false;
      this.progresso = 0;
    };
    this.uploaderDocumento.onAfterAddingFile = (file) => {
      file.withCredentials = false;
    };
    this.uploaderDocumento.onProgressItem = (
      fileItem: FileItem,
      progress: any
    ) => {
      console.log(
        "[modale-versioni-documento][onProgressItem] " +
        fileItem +
        ", progresso: " +
        progress
      );
      this.progresso = fileItem.progress;
    };

    this.uploaderDocumento.onSuccessItem = (item: any, response: any) => {
      console.log("ModaleAggiungiUd.constructor] onSuccessItem: ", item);
      const res: ResponseUploadFileVO = <ResponseUploadFileVO>(
        JSON.parse(response)
      );
      console.log(
        "**** controllo se già presente ",
        this.listaVersioniDocumento,
        res.id,
        this.listaVersioniDocumento.filter(
          (value) => value.idRepository === res.id
        ).length
      );
      /*       this.documentoService.getDocumento(res.id).subscribe((docRemoto) => {
        if (docRemoto && docRemoto.idRepository === res.id) {
          this.notifierService.notify(
            "error",
            "La versione del documento che si sta caricando è già presente nel sistema!"
          );
          this.inizializzaUploader();
        }
      }); */
      if (
        this.listaVersioniDocumento.filter(
          (value) => value.idRepository === res.id
        ).length > 0
      ) {
        this.notifierService.notify("error", "Versione già caricata!");
        this.inizializzaUploader();
      } else {
        this.idRepository = res.id;
        this.nomeFile = item.file.name;
        this.riferimentiRepository.id = res.id;
        this.riferimentiRepository.hash = res.hash;
        this.riferimentiRepository.nome = item.file.name;
      }
    };
  }

  public upload(riferimentiRepository: DocumentoGescorVO) {
    console.log("upload1", riferimentiRepository);
    this.inCaricamento = true;
    this.uploadEmit.emit(riferimentiRepository);
    //    this.modalRef.hide();
  }

  ripristina(id: string, hash: string, nome: string) {
    this.idDaRipristinare = id;
    this.hashDaRipristinare = hash;
    this.nomeDaRipristinare = nome;
    this.titolo = "Ripristino versione";
    this.testo = "Vuoi veramente ripristinare questa versione?";
    this.modaleConfermaRipristina.openModal();
  }

  public confermaRipristina(conferma: boolean) {
    console.log("confermaRipristina", conferma);
    if (conferma) {
      const riferimentiRepository = new DocumentoGescorVO();
      riferimentiRepository.id = this.idDaRipristinare;
      riferimentiRepository.hash = this.hashDaRipristinare;
      riferimentiRepository.nome = this.nomeDaRipristinare;
      console.log("ripristina", riferimentiRepository);
      this.ripristinaEmit.emit(riferimentiRepository);
    }
  }

  public rimuoviDocumento() {
    console.log("rimuoviDocumento");
    this.hash = "";
    this.idRepository = "";
    this.nomeFile = "";
    this.inizializzaUploader();
  }

  public showPreviewModal(idDocumento: string) {
    console.log("Apro modale? ", idDocumento);
    this.previewModal.openModal();
    this.idDocumentoPreview = idDocumento;
    this.showPreviewDoc = true;
  }

  public controllaFirma(id: string) {
    console.log("controllaFirma", id);
    this.modaleControlloFirma.openModal(id);
  }

  ngOnDestroy(): void {
    if (this.utenteSubscription) {
      this.utenteSubscription.unsubscribe();
    }
  }
}
